module.exports = __webpack_public_path__ + "53b986cc49b33510a4a0e945a99144d3.svg";